import { cn } from "@/lib/utils";

type StatusType = "ok" | "pending";

interface StatusBadgeProps {
  status: StatusType;
  label?: string;
  className?: string;
}

export function StatusBadge({ status, label, className }: StatusBadgeProps) {
  const baseClasses =
    "inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-semibold uppercase tracking-wide border";

  const statusClasses =
    status === "ok"
      ? "bg-emerald-100 text-emerald-700 border-emerald-200"
      : "bg-amber-100 text-amber-700 border-amber-200";

  const defaultLabel = status === "ok" ? "OK" : "Pendente";

  return (
    <span className={cn(baseClasses, statusClasses, className)}>
      <span className="h-2 w-2 rounded-full bg-current" aria-hidden="true" />
      {label ?? defaultLabel}
    </span>
  );
}

export default StatusBadge;
